<template>
  <b-form-radio-group
    v-model="selectedValue"
    :disabled="disabled"
    :class="classGrid"
    :key="pergunta && pergunta.cd_pergunta"
  >
    <label
      v-for="opcao in opcoes"
      class="radio-card"
      :key="opcao.cd_resposta"
      :for="getInputId(opcao.cd_resposta)"
      :class="{ active: estaSelecionada(opcao.cd_resposta), disabled }"
    >
      <b-form-radio
        class="radio-input"
        :value="opcao.cd_resposta"
        :id="getInputId(opcao.cd_resposta)"
      />

      <div class="custom-content content">
        <div class="title">{{ opcao.ds_resposta }}</div>
        <div v-if="opcao.ds_observacao" class="description">
          {{ opcao.ds_observacao }}
        </div>
      </div>
    </label>
  </b-form-radio-group>
</template>

<script lang="js">
export default {
  name: "RespostaRadio",

  props: {
    pergunta: {
      type: Object,
      required: true
    },
    modelValue: {
      type: [String, Number, Array],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    selectedValue: {
      get() {
        if (Array.isArray(this.modelValue)) {
          return this.modelValue[0] || null;
        }

        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      }
    },

    opcoes() {
      return Array.isArray(this.pergunta?.respostas)
        ? this.pergunta.respostas
        : [];
    },
    classGrid() {
      return this.opcoes.length > 3 ? "resposta-radio-grid" : "resposta-radio";
    }
  },

  methods: {
    getInputId(cdResposta) {
      const perguntaId = this.pergunta?.cd_pergunta || "pergunta";
      return `resposta-radio-${perguntaId}-${cdResposta}`;
    },

    estaSelecionada(cdResposta) {
      const valorSelecionado = Array.isArray(this.modelValue)
        ? this.modelValue[0]
        : this.modelValue;

      return String(valorSelecionado) === String(cdResposta);
    }
  }
};
</script>

<style lang="scss">
.resposta-radio {
  gap: 5px;
  display: flex;
  flex-direction: column;
}

.resposta-radio-grid {
  display: grid;
  column-gap: 15px;
  grid-template-columns: repeat(2, 1fr);
}

.radio-card {
  gap: 5px;
  display: flex;
  padding: 16px;
  cursor: pointer;
  border-radius: 10px;
  align-items: center;
  transition: all 0.2s ease;
  border: 1px solid rgb(226 232 240 / 1);
}

.radio-card:hover {
  border-color: rgb(0 146 63 / 0.5) !important;
  background-color: rgb(248 249 250 / 1) !important;
}

.radio-card.active {
  border-color: #149a4e;
  background: #f2f9f5;
}

.radio-card.disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.radio-input {
  flex-shrink: 0;
}

.content {
  display: flex;
  padding: 0 !important;
  flex-direction: column;
  margin-top: 0 !important;
}

.title {
  font-weight: 600;
  color: #0d2345;
}

.description {
  font-size: 0.875rem;
  color: #6c757d;
  margin-top: 4px;
  line-height: 1.4;
}

.radio-card input[type="radio"] {
  font-size: large !important;
}

.radio-card input[type="radio"]:checked {
  background: #00923f;
  border-color: #00923f;
}

@media (max-width: 576px) {
  .resposta-radio-grid {
    row-gap: 5px;
    grid-template-columns: repeat(2, 1fr);
  }

  .radio-card {
    padding: 8px 10px;
  }

  .radio-card input[type="radio"] {
    font-size: small !important;
  }
}
</style>
